import List from '@utils/list'
import getData from './config/getData'
import MultipleTable from '@utils/multiple-table'
import CheckboxSelect from '@/components/select/checkbox-select/checkbox-select.vue'
import { tablePrint } from '@utils/index'
import detail from './config/detail'
import http from '@/plugin/axios'
const { Search, Tabs, Table, Jurisdiction, Operation } = List

function orderreply(this: any, data: any) {
  const { purchaseNo, purchaseSeq, purchasePhaseSeq } = data
  this.$router.push({ name: 'Ordersupplier.Ordertrack.Orderreply', query: { purchaseNo, purchaseSeq, purchasePhaseSeq }})
}

const operation = new Operation('ordersupplier.ordertrack')
  .width(110)
  .add('orderreply').handle(orderreply).disabled(row => row.status !== '1' && row.status !== '2')

function printTable(this: any) {
  tablePrint({
    url: '/srmPurchaseHead/printOrderBatch',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { purchaseNos: this.selection.map((i: any) => i.purchaseNo).join(',') }
  })
}
function confirmDisabled(selection: any[]) {
  if (!selection.length) return true
  const noStatus1 = selection.filter(item => item.status !== '1')
  if (noStatus1.length) return 'ordersupplier.ordertrack.notStatus1'
  return false
}

async function batchConfirm(this: any) {
  await this.$confirm(this.$t('ordersupplier.ordertrack.batchConfirmTip'))
  await http({
    url: '/srmPurchaseHead/confirmOrder',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: { purchaseNos: this.selection.map((i: any) => i.purchaseNo).join(',') }
  })
  this.refresh()
}
const jurisdiction = new Jurisdiction('ordersupplier.ordertrack')
  .add('batchConfirm').icon('icon-querendingdan').disabled(confirmDisabled).handle(batchConfirm)
  .lib('print').handle(printTable).disabled(selection => !selection.length)

const tabs = new Tabs()
  .url('/srmPurchaseHead/getPurchaseHeadStatusCount', process.env.VUE_APP_PURCHASE_API)
  .default('0')
  .name('orderTypeName')
  .value('orderType')
  .count('orderTypeAmount')

const extra = new Search('ordersupplier.ordertrack')
  .add('orderType').op('orderType').bind('placeholder', 'ordersupplier.ordertrack.orderTypePlaceholder')
  .add('overdueFlag').label('').component(CheckboxSelect).bind('text', 'ordersupplier.ordertrack.overdueFlag').default('N')

const search = new Search('ordersupplier.ordertrack')
  .placeholder('searchPlaceholder')
  .extra(extra)
  .searchOnExtraChange()
  .add('purchaseUnitNo').select('/purchaseUnit/getPurchaseUnitPage', { usingFlag: '1' })
  .add('startPurchaseDate').merge('date').label('startPurchaseDate')
  .add('endPurchaseDate').merge('date').label('endPurchaseDate')
  .add('startDeliveryDate').merge('date').label('startDeliveryDate')
  .add('endDeliveryDate').merge('date').label('endDeliveryDate')
  .add('goodsNo')
  .add('goodsName')
  .add('spec')

const childTable = new Table('ordersupplier.ordertrack')
  .type('index')
  .sortable(false)
  .operation(operation)
  .add('purchaseSeqAndPurchasePhaseSeq').format(data => `${data.row.purchaseSeq}-${data.row.purchasePhaseSeq}`).width(110)
  .add('goodsNo').width(110)
  .add('goodsName')
  .add('spec').width(110)
  .add('batchPurQty').width(110)
  .add('undeliveredQty').width(110)
  .add('unReceiveQty').html(data => `<span${data.value > 0 ? ' style="color: red;"' : ''}>${data.value}</span>`)
  .add('shipmentQty')
  .add('onWayQty')
  .add('expectedArrivalDate').date()
  .add('replyDeliveryNum')
  .add('statusName')

const table = new MultipleTable('ordersupplier.ordertrack')
  .table(childTable)
  .listProp('list')
  .add('purchaseNo').link()
  .add('settleOfficeName')
  .add('purchaseDate')
  .add('purOfficeName')

export default new List()
  .api(getData)
  .jurisdiction(jurisdiction)
  .tabs(tabs)
  .search(search)
  .table(table)
  .detail(detail)
  .end()
